import { actions } from "../../ovlsyscomponents/syslogin01/features/actions"
import { Data } from "../dataapi"
import { postRequest } from "../effects"
import { _handleDialogVisible, handleScreenVisible } from "../helpers"
import type {
  SYSAction,
  SYSActions,
  SYSFeature,
  SYSScreen,
  SYSState,
  SYSTableDefIds,
} from "../index"
import { SYSConfig, currentScreenAndDialog, ovl } from "../index"

import { DialogOkCancel } from "../library/dialog/dialogapi"
import type { DialogsState } from "../library/dialog/sysdialogbase"
import { _setDialogVisible } from "../library/forms/helper"
import { setVisibleValidation } from "../library/forms/validators"

import {
  ProcessEnd,
  ProcessStart,
} from "../library/longrunningprocesstracker/processapi"
import {
  NavigateToScreenOptionsType,
  ScreenCurrent,
  ScreenCurrentState,
  ScreenNavigateBack,
  ScreenNavigateTo,
} from "../library/screenapi"
import { SnackAdd } from "../library/snackapi"
import { setLastScrollPosition } from "../library/sysbaseelement"
import { SYSTableDef, TableGet } from "../library/table/tableapi"
import { sessionStore, stateStore } from "../offlinestorage"

import { AddGlobalReactor } from "../tracker/reactor"
import { FileGetDefaultUrl, SessionUpdate } from "./globalapi"
import { ResetT, T, _ShowFile, hasOSReducedMotion, logout } from "./globals"
import {
  HookAppAfterRehydrate,
  HookAppUrlResolver,
  HookAppUrlResolver_Type,
  HookScreenNavigateIn,
  HookScreenNavigateIn_Type,
  HookScreenNavigateOut,
  HookScreenNavigateOut_Type,
} from "./hooks"

export const _SetLastScrollPosition: SYSAction = (_, { global }) => {
  let state = global.getState()
  setLastScrollPosition(state.ovl.screens)
}

export let screenFadedOutResolver

type _NavigateScreenOptionsType = {
  instance: any
  fromRehydrate?: boolean
}

export const _Navigate: SYSAction<{
  screen: SYSScreen
  navigateBack?: boolean
  options?: _NavigateScreenOptionsType
}> = async ({ screen, navigateBack, options }, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let screensState = state.ovl.screens
  if (screensState.nav.isNavigating) {
    return
  }

  let currentScreenState = ScreenCurrentState()
  if (currentScreenState) {
    if (
      currentScreenState.screen === screen &&
      (options?.instance === undefined ||
        currentScreenState.instance === options?.instance)
    ) {
      return
    }
  }
  let savedPreviousScreen = screensState.nav.previousScreen
  let savedPreviousScreenContext = screensState.nav.previousScreenInstance
  let instance = options?.instance
  if (instance === undefined) {
    instance = screen
  }
  if (screensState.screens[screen]?.instance[instance] === undefined) {
    // console.log(screen)
    // if (screensState.screens[screen] === undefined) {
    //   screensState.screens[screen] = { instance: {} }
    // }
    // if (screensState.screens[screen]?.instance === undefined) {
    //   screensState.screens[screen]["instance"] = {}
    // }
    screensState.screens[screen].instance[instance] = {
      screen: screen,
      instance: instance,
      visible: false,
      closing: false,
      lastScrollTop: 0,
      focus: {
        focusSet: false,
        focusWhenLeft: undefined,
      },
    }
  }
  if (
    options?.fromRehydrate !== true &&
    currentScreenState?.screen === screen &&
    currentScreenState?.instance === instance
  ) {
    return
  }
  screensState.nav.isNavigating = true
  let screenElement
  let navDirection = navigateBack ? "Back" : "Forward"
  try {
    let hooks

    // call navigateOut. for now ignore navigateout when coming from rehydrate
    if (currentScreenState?.screen != undefined && !options?.fromRehydrate) {
      hooks = actions.app.screens?.[currentScreenState.screen]?.hooks
      if (hooks && hooks[HookScreenNavigateOut]) {
        let navigateOutResult = await hooks[HookScreenNavigateOut](<
          HookScreenNavigateOut_Type
        >{
          navDirection,
          screen: currentScreenState.screen,
          toScreen: screen,
          instance:
            state.ovl.screens.screens[currentScreenState.screen].instance
              .context,
        })
        if (navigateOutResult) {
          return
        }
      }
    }
    hooks = actions.app.screens?.[screen]?.hooks

    let screenHookPromise
    if (hooks && hooks[HookScreenNavigateIn]) {
      screenHookPromise = hooks[HookScreenNavigateIn](<
        HookScreenNavigateIn_Type
      >{
        navDirection: navigateBack ? "Back" : "Forward",
        screen,
        fromScreen: currentScreenState?.screen,
        instance: instance,
      })
    }

    if (
      options?.fromRehydrate &&
      currentScreenState?.screen === screen &&
      currentScreenState?.instance === instance
    ) {
      if (screensState.screens[screen].noHistory !== true) {
        screensState.nav.screensHistory.push({ screen: screen, instance })
      }
      if (screenHookPromise !== undefined) {
        await screenHookPromise
      }
      return
    }
    let screenFadedOutPromise
    if (currentScreenState?.screen !== undefined) {
      screenFadedOutPromise = new Promise<any>((resolve, reject) => {
        screenFadedOutResolver = resolve
      })
      screenElement = document.getElementById(
        `ovlscreen_${currentScreenState.screen}_${currentScreenState.instance}`
      )

      if (screenElement) {
        screenElement.classList.remove("fadeInScreen")
        screenElement.classList.add("fadeOutScreen")
        screenElement.classList.add("ovl-disabled")
        if (hasOSReducedMotion()) {
          screenFadedOutResolver(true)
          //screenFadedOutResolver = undefined
        } else {
          // do not track whilst fading out screen
          screenElement.classList.add("trackingBlock")
        }
      }
    }
    screensState.nav.previousScreen = screensState.nav.nextScreen
    screensState.nav.previousScreenInstance =
      screensState.nav.nextScreenInstance
    screensState.nav.nextScreen = screen
    screensState.nav.nextScreenInstance = instance
    let screenHookPromiseRes
    await screenFadedOutPromise
    if (screenHookPromise !== undefined) {
      screenHookPromiseRes = await screenHookPromise
    }

    if (screenHookPromise !== undefined && screenHookPromiseRes) {
      // will be handled in the catch
      throw new Error()
    }
    //}
    actions.ovl.internal._SetLastScrollPosition()
    if (currentScreenState?.screen) {
      screensState.screens[currentScreenState.screen].instance[
        currentScreenState.instance
      ].visible = false
      handleScreenVisible(
        currentScreenState.screen,
        false,
        currentScreenState.instance
      )
    }
    screensState.screens[screen].instance[instance].disabled =
      isScreenDisabledByRunningProcess(state, instance)
    if (!navigateBack) {
      if (screensState.screens[screen].noHistory !== true) {
        state.ovl.screens.nav.screensHistory.push({ screen, instance })
      } else if (
        screensState.screens[currentScreenState.screen].noHistory !== true
      ) {
        state.ovl.screens.nav.screensHistory.push({
          screen: currentScreenState.screen,
          instance: currentScreenState.instance,
        })
      }
      screensState.screens[screen].instance[instance].instance = instance
    } else {
      if (state.ovl.screens.nav.screensHistory.length > 1) {
        if (screensState.screens[screen].noHistory !== true) {
          state.ovl.screens.nav.screensHistory.pop()
        }
      }
    }
    screensState.screens[screen].instance[instance].visible = true
    handleScreenVisible(screen, true, instance)
  } catch (e) {
    console.log(e)
    if (currentScreenState) {
      screensState.nav.nextScreen = currentScreenState.screen
      screensState.nav.nextScreenInstance = currentScreenState.instance
      screensState.nav.previousScreen = savedPreviousScreen
      screensState.nav.previousScreenInstance = savedPreviousScreenContext
    }
    if (screenElement) {
      screenElement.classList.remove("fadeOutScreen")
      screenElement.classList.remove("trackingBlock")
      screenElement.classList.remove("ovl-disabled")
      screenElement.classList.add("fadeInScreen")
    }
    if (!currentScreenState) {
      // there was nothing before (eg. usecase routed directly to screen)
      setTimeout(async () => {
        if (SYSConfig.init.initalScreen) {
          await ScreenNavigateTo(SYSConfig.init.initalScreen)
        }
      }, 1000)
    }
  } finally {
    state.ovl.screens.nav.isNavigating = false
  }
}
export const isScreenDisabledByRunningProcess = (
  state: SYSState,
  instance: any
) => {
  let processTracker = state.ovl.longRunningProcessTracker
  return Object.keys(processTracker).some((f) => {
    processTracker[f].lockScreen &&
      Object.keys(processTracker[f].instance).some(
        (s) => s === instance && processTracker[f].instance[s].isRunning
      )
  })
}

export const _SetPortalTestingMode: SYSAction<boolean> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let res = await Data("users/setportaltestingmode", { IsTest: value })
  state.ovl.app.isPortalTestingMode = value
}

export const _SetLanguage: SYSAction<{
  language: string
  startup: boolean
}> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let lang = value.language
  let startup = !!value.startup
  let res = await Data("users/translations", {
    language: lang,
    startup,
  })

  ResetT()

  /* checking for undefined and null because less dependent on backend... */
  let language = state.ovl.language
  if (language.translations === undefined && language.translations !== null) {
    language.translations = {}
  }
  Object.keys(res.data.translations).forEach((k) => {
    language.translations[k] = res.data.translations[k]
  })
  if (res.data.lang !== undefined && res.data.lang !== null) {
    await SessionUpdate("Language", res.data.lang)
  }
  if (
    res.data.availableTranslations !== undefined &&
    res.data.availableTranslations !== null
  ) {
    language.availableTranslations = res.data.availableTranslations
  }
  if (
    res.data.translationFallbackLanguage !== undefined &&
    res.data.translationFallbackLanguage !== null
  ) {
    language.translationFallbackLanguage = res.data.translationFallbackLanguage
  }

  if (res.data.isTest !== undefined && res.data.isTest !== null) {
    state.ovl.app.isPortalTestingMode = res.data.isTest
  }
  if (res.data.pwRegex !== undefined && res.data.pwRegex !== null) {
    state.ovl.app.pwRegex = res.data.pwRegex
  }
  if (res.data.runMode !== undefined && res.data.runMode !== null) {
    state.ovl.app.runMode = res.data.runMode
  }

  if (
    res.data.enablePasswordVisibility !== undefined &&
    res.data.enablePasswordVisibility !== null
  ) {
    state.ovl.app.enablePasswordVisibility = res.data.enablePasswordVisibility
  }

  if (res.data.testingEmail !== undefined && res.data.testingEmail !== null) {
    state.ovl.app.testingEmail = res.data.testingEmail
  }

  if (res.data.backendType !== undefined && res.data.backendType !== null) {
    state.ovl.app.backendType = res.data.backendType
  }

  state.ovl.app.translationsVariationId =
    res?.data?.translationsVariationId ?? state.ovl.app.translationsVariationId

  if (res.data.actorTOTP !== undefined) {
    state.ovl.app.actorTOTP = res.data.actorTOTP
  }

  if (res.data.defaultAuthMode !== undefined) {
    state.ovl.app.defaultAuthMode = res.data.defaultAuthMode
  }

  if (
    res.data.translationComplete !== undefined &&
    res.data.translationComplete !== null
  ) {
    state.ovl.language.translationComplete = res.data.translationComplete
  }
  if (res.data.versionInfo !== undefined) {
    SYSConfig._system.versionInfo.backend = {
      app: res.data.versionInfo.app,
      ovl: res.data.versionInfo.ovl,
    }
  }

  if (res.data.fileUploadRestrictions) {
    state.ovl.app.fileUploadRestrictions = res.data.fileUploadRestrictions
  }

  if (res.data.consoleToAudit) {
    state.ovl.app.consoleToAudit = res.data.consoleToAudit
  }

  // also set body lang fro screenreaders, spellcheck, etc
  let body = document.getElementsByTagName("body")[0]
  let langCode
  switch (res.data.lang) {
    case "DE":
      langCode = "de-CH"
      break
    case "FR":
      langCode = "fr-CH"
      break
  }
  body.setAttribute("lang", state.ovl.session.Language)
  if (res.data.additionalRes !== undefined && res.data.additionalRes !== null) {
    let fn = actions.app.global?.hooks?.["HookHandleAdditionalLanguageResult"]
    if (fn) {
      fn(res.data.additionalRes)
    }
  }
}

export const _Logout: SYSAction<{ force?: boolean }> = async (
  _,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  if (_.force) {
    await postRequest(`${state.ovl.apiUrl}users/logout`, {})
    logout()
    return
  }
  if (
    (state.ovl.app.offline.api || state.ovl.app.offline.site) &&
    SYSConfig.offline.enabled
  ) {
    SnackAdd(
      "Abmelden und Neuinitialisierung nur im Onlinemodus möglich!",
      "Error"
    )
    return
  }
  if ((await DialogOkCancel(T("SYSLoginLogoutConfirm"))) === 1) {
    //if (SYSConfig.fetch.authMode === "cookie") {
    await postRequest(`${state.ovl.apiUrl}users/logout`, {})
    //}
    logout()
  }
}

export const _GetFile: SYSAction<{
  url: string
  dataToUrlParams: {}
  feature?: SYSFeature
  fileName?: string
  ignoreSnack?: boolean
}> = async (value) => {
  let url = value.url
  if (!url) {
    url = FileGetDefaultUrl()
  }
  try {
    let processOptions
    if (value.ignoreSnack) {
      processOptions = { snack: { type: "none" } }
    }
    ProcessStart("SYSFileGet", processOptions)
    let res = await Data(undefined, value.dataToUrlParams, {
      expectBlob: true,
      method: "GET",
      customUrl: url,
    })
    if (res.status === 200) {
      //let mimeType = res.headers["content-type"]

      await _ShowFile(
        res.data,
        undefined,
        value.feature,
        value.fileName,
        res.headers
      )
    }
  } finally {
    ProcessEnd("SYSFileGet")
  }
}

export const _RehydrateApp: SYSAction<
  {
    storeId: string
    fn?: (state: SYSState) => {}
    contents?: string
  },
  Promise<boolean>
> = async (value, { global }) => {
  if (
    value.storeId !== undefined ||
    value.contents ||
    SYSConfig.offline.enabled
  ) {
    try {
      let state = global.getState()
      let persistedState
      if (!value.contents) {
        let stateStoreId = SYSConfig._system.statePersistVersion.toString()
        if (value.storeId !== undefined) {
          stateStoreId = `${stateStoreId}_User_${value.storeId}`
        }
        persistedState = await stateStore.get(stateStoreId)
      } else {
        persistedState = JSON.parse(value.contents)
      }

      let offlineState = JSON.parse(JSON.stringify(state.ovl.app.offline))
      let currentScreen = state.ovl.screens.nav.nextScreen
      let currentScreenInstance = state.ovl.screens.nav.nextScreenInstance
      if (!persistedState) {
        // clear also maybe old versions lingering around...
        stateStore.clear()
      } else {
        if (value.fn) {
          value.fn(persistedState)
        }
        // // set all screens, dialogs to visible false
        let screens = state.ovl.screens.screens
        let dialogs = state.ovl.dialogs
        Object.keys(dialogs).forEach((f) => {
          Object.keys(dialogs[f].instance).forEach((instance) => {
            dialogs[f].instance[instance].closing = false
            dialogs[f].instance[instance].visible = false
          })
        })

        Object.keys(screens).forEach((f: SYSScreen) => {
          Object.keys(screens[f].instance).forEach((instance) => {
            screens[f].instance[instance].visible = false
            screens[f].instance[instance].closing = false
            screens[f].instance[instance].disabled = false
          })
        })
        let persistedDialogs = persistedState.ovl.dialogs
        let persistedDialogsClone = JSON.parse(
          JSON.stringify(persistedState.ovl.dialogs)
        )
        Object.keys(persistedDialogs).forEach((f) => {
          Object.keys(persistedDialogs[f].instance).forEach((instance) => {
            persistedDialogs[f].instance[instance].visible = false
            persistedDialogs[f].instance[instance].closing = false
          })
        })

        let visibleScreen: SYSScreen
        let visibleScreenInstance: string
        let persistedScreens = persistedState.ovl.screens.screens
        Object.keys(persistedScreens).some((s: SYSScreen) => {
          return Object.keys(persistedScreens[s].instance).some((instance) => {
            if (persistedScreens[s].instance[instance].visible) {
              visibleScreen = s
              visibleScreenInstance = instance
              return true
            }
          })
        })
        // reset screenContainer
        // we always need a rerender of the container and the containing screen
        // test timeport effort saveuserstate, reload page rehydrate then reload efforts -> we had double efforts and the following line i a part of that fix
        currentScreenAndDialog.screens = []
        // 09.08.2024, knp: Tables create dynamic data[id] -> ids for every row in rebuild
        // those are different from the one saved in peristedstate
        // thats why we need to reset all the tables

        Object.keys(SYSConfig.app.tableDefIds).forEach((tid) => {
          // rebuild SYSConfig for all dynamically added tabledef ids
          // usecase BAR Activities
          let datadef0 = SYSConfig.app.tableDefIds[tid]
          let datadef = datadef0.getData(state)
          Object.keys(datadef.tableDef).forEach((td) => {
            if (!SYSConfig.app.tableDefIds[td]) {
              SYSConfig.app.tableDefIds[td] = datadef0
            }
          })
        })

        // await Promise.all(
        //   Object.keys(SYSConfig.app.tableDefIds).map((tableDefId) => {
        //     let tb = TableGet(<SYSTableDefIds>tableDefId)
        //     if (tb.def.initialised) {
        //       return tb.init({ resetStrategy: { ClearData: true } })
        //     }
        //   })
        // )

        // 09.08.2024, knp: We need Merge here because elsewise we will loose reactivity (proxy references need to stay)
        MergeDeep(state, persistedState)

        let fn = ovl.getActions().app.global?.hooks?.[HookAppAfterRehydrate]
        if (fn) {
          await fn(ovl.getActions())
        }

        // setVisibleValidation for forms
        let formsState = state.ovl.forms

        Object.keys(formsState).forEach((formtype) => {
          let formsInstanceState = formsState[formtype]
          Object.keys(formsInstanceState).forEach((formId) => {
            let formState = formsState[formtype][formId]
            setVisibleValidation(formState, 0)
          })
        })

        setTimeout(async () => {
          SnackAdd("Rehydrate App...", "BusyIndicator", 6000)

          if (visibleScreen) {
            state.ovl.uiState.appIsScreenNavigateInRehydrating = true
            if (persistedScreens[visibleScreen].callNavigateInHookOnRehydrate) {
              let hooks = ovl.getActions().app.screens[visibleScreen].hooks
              if (hooks?.[HookScreenNavigateIn]) {
                await hooks[HookScreenNavigateIn](<HookScreenNavigateIn_Type>{
                  navDirection: "Forward",
                  screen: visibleScreen,
                  instance: visibleScreenInstance,
                })
              }
            }
            state.ovl.uiState.appIsScreenNavigateInRehydrating = false

            handleScreenVisible(visibleScreen, true, visibleScreenInstance)
          }

          // now recreate dialogs in zIndex Order
          setTimeout(async () => {
            let res: DialogsState[] = []
            Object.keys(persistedDialogsClone).forEach((f) =>
              Object.keys(persistedDialogsClone[f].instance).forEach(
                (instance) => {
                  if (
                    persistedDialogsClone[f].instance[instance].visible &&
                    !persistedDialogsClone[f].instance[instance].closing
                  ) {
                    res.push(persistedDialogsClone[f].instance[instance])
                  }
                }
              )
            )
            res.sort((a, b) => a.zIndex - b.zIndex)
            for (let i = 0; i < res.length; i++) {
              let f = res[i]
              AddGlobalReactor(
                [`ovl.dialogs.${f.dialog}.instance.${f.instance}.visible`],
                _handleDialogVisible
              )

              _setDialogVisible(
                true,
                state.ovl.dialogs[f.dialog].instance[f.instance]
              )
              await new Promise((resolve) => setTimeout(resolve, 400))
            }
          }, 0)
        }, 500)
        state.ovl.app.ready = true
        // use always current offline state
        state.ovl.app.offline = offlineState

        return true
      }
    } catch (e) {
      console.error("Persisted Offlinedata could not be restored: ")
      console.error(e)
      return false
    }
  }
}

function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item)
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function MergeDeep(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        MergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return MergeDeep(target, ...sources)
}

export const Rehydrate = async (
  actions: SYSActions,
  id?: string,
  fn?: (state: SYSState) => {},
  contents?: string
): Promise<boolean> => {
  try {
    if (
      await actions.ovl.internal._RehydrateApp({
        storeId: id,
        fn,
        contents,
      })
    ) {
      ovl.getState().ovl.uiState.appRehydrated = true
      return true
    }
  } catch (e) {
    console.log("Rehydrate Error:")
    console.error(e)
  }
  return false
}

export const _InitApp: SYSAction = async (_, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  // this clears caches and unregister sw
  if (window.location.search.toLowerCase().indexOf("ovlreset") > -1) {
    logout()
  }

  history.scrollRestoration = "manual"
  history.pushState(null, null, document.URL)
  window.addEventListener("popstate", async function (e) {
    if (!document.getElementById("ovl-dialog")) {
      await ScreenNavigateBack()
      history.pushState(null, null, document.URL)
    }
  })

  // set correct api url

  try {
    let apiResolverHookFn = actions.app.global.hooks?.[HookAppUrlResolver]
    if (apiResolverHookFn) {
      let urlResolverToSet: HookAppUrlResolver_Type = {
        apiUrlToSet: undefined,
        wsUrlToSet: undefined,
        isDemoToSet: false,
        isTestingToSet: false,
        cleanUrlToSet: true,
      }
      apiResolverHookFn(urlResolverToSet)
      if (urlResolverToSet.apiUrlToSet) {
        if (!urlResolverToSet.apiUrlToSet.endsWith("/")) {
          urlResolverToSet.apiUrlToSet += "/"
        }
        state.ovl.apiUrl = urlResolverToSet.apiUrlToSet
      }
      if (urlResolverToSet.wsUrlToSet) {
        if (!urlResolverToSet.wsUrlToSet.endsWith("/")) {
          urlResolverToSet.wsUrlToSet += "/"
        }
        state.ovl.wsUrl = urlResolverToSet.wsUrlToSet
      } else {
        state.ovl.wsUrl = state.ovl.apiUrl.replace("http", "ws")
      }
      state.ovl.uiState.isDemo = !!urlResolverToSet.isDemoToSet
      state.ovl.app.isPortalTestingMode = !!urlResolverToSet.isTestingToSet
      state.ovl.app.cleanUrl = !!urlResolverToSet.cleanUrlToSet
      // sets offline.api boolean
      await ApiOnlineCheck()
    }

    if (SYSConfig.offline.enabled) {
      // Update check checks if the client needs to be updated and also sets offline.site boolean
      await SiteUpdateCheck()
      if (state.ovl.app.offline.api || !state.ovl.apiUrl) {
        if (!(await Rehydrate(actions, undefined, undefined))) {
          alert(
            "There is no api and a previous state could not be loaded from browser db!"
          )
          window.location.reload()
          return
        } else {
          console.log("app rehydrated...")
        }
      }
    }
  } catch {
    if (state.ovl.app.offline.api) {
      await setTimeout(() => {
        logout()
      }, 10000)
    }
  }
  let customInitFn = actions.app.global?.hooks?.HookAppInit
  if (customInitFn) {
    await customInitFn()
  }
  if (!SYSConfig.translation.useLocal && !state.ovl.uiState.appRehydrated) {
    let sessionBase = await sessionStore.get("base")
    let lang = sessionBase?.Language

    await actions.ovl.internal._SetLanguage({
      language: lang,
      // if there is no login used at all (OttoRohr, TimePortal KaltAG, always get all translations)
      startup:
        actions.app.features?.["SYSLogin"]?.hooks?.["HookSYSLoginSuccess"] !==
        undefined,
    })
  }
}

export const SiteUpdateCheck = async () => {
  if (SYSConfig.offline.enabled) {
    // lets try to get the version.js file named exactly after the version in state from site server
    // if it fails with a 404 that means we have network but the file couldn't be found because it has a different version in name
    // in that case we need to update
    // which in turn will clear all the serviceworker,indexeddb using the logout() function currently
    // a 404 because if not offline mode this means we have connection
    try {
      var headers = new Headers()
      headers.append("pragma", "no-cache")
      headers.append("cache-control", "no-cache")

      let fetchOptions = new Request(
        "./itfprtclientassets/ovlnocache/" +
          SYSConfig._system.versionInfo.frontend.app.version
            .split(".")
            .join("_") +
          ".js",
        {
          method: "get",
          headers,
        }
      )
      let response = await fetch(fetchOptions)

      ovl.getState().ovl.app.offline.site = false
      if (response.status === 404) {
        alert("Update needed!")
        logout()

        // we need an update if we are in offline mode
      }
    } catch (e) {
      ovl.getState().ovl.app.offline.site = true
    }
  }
}

export const ApiOnlineCheck = async () => {
  // lets try to access the api url
  // a 404 because if not offline mode this means we have connection
  try {
    let fetchOptions = new Request(ovl.getState().ovl.apiUrl, {
      method: "post",
    })
    let response = await fetch(fetchOptions)
    ovl.getState().ovl.app.offline.api = false
  } catch (e) {
    if (SYSConfig.offline.enabled) {
      console.info("ApiOnlineCheck failed. Proceed with offline Mode")
    }
    ovl.getState().ovl.app.offline.api = true
  }
}
